import API_Calls_Dashboard from "@/api/calls/API_Calls_Dashboard";
import API_Calls_Template from "@/api/calls/API_Calls_Template";
import { getValidLocalStorageItem } from "@/utils/util";

const useGetCachesHandler = () => {
  const { getFormulae, getPriority, fetchNewTemplate } = API_Calls_Template();
  const { getDefaultCatalistFields } = API_Calls_Dashboard();

  const checkCacheAndReturnData = async (cacheName, APICall) => {
    const cachedData = getValidLocalStorageItem(cacheName);
    if (cachedData) {
      return cachedData;
    } else {
      const response = await APICall();
      if (response.data) {
        localStorage.setItem(cacheName, JSON.stringify(response.data));
      } else {
        console.error(response.message);
      }
      return response.data;
    }
  };

  const getFormulaeCache = async () => {
    return checkCacheAndReturnData("formula_data", getFormulae);
  };

  const getEmptyTemplate = () => {
    return checkCacheAndReturnData("template_skeleton", fetchNewTemplate);
  };

  const getPriorityFields = async () => {
    return checkCacheAndReturnData("priority_fields", getPriority);
  };

  const loadDefaultCatalistFields = async () => {
    return checkCacheAndReturnData("catalist_fields", getDefaultCatalistFields);
  };

  return {
    getFormulaeCache,
    getEmptyTemplate,
    getPriorityFields,
    loadDefaultCatalistFields,
  };
};

export default useGetCachesHandler;
